import { Reveal, Overline } from "./Reveal";

export default function PageHeader({ overline, title, subtitle, accent }) {
  return (
    <section className="relative pt-40 pb-16 sm:pt-48 sm:pb-20 overflow-hidden grain">
      <div className="absolute inset-0 gold-glow pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <Reveal>
          {overline && <Overline>{overline}</Overline>}
          <h1 className="font-serif text-5xl sm:text-6xl font-bold leading-none mt-5">
            {title} {accent && <span className="text-gold-gradient">{accent}</span>}
          </h1>
          {subtitle && (
            <p className="mt-6 text-base sm:text-lg text-muted2 max-w-2xl mx-auto leading-relaxed">
              {subtitle}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
